import React, { useState, useEffect, useContext } from 'react';
import { observer } from 'mobx-react';
import { useStore } from 'core/store';
import { Label } from 'core/components/label';
import PropTypes from 'prop-types';

import { AuthContext } from 'core/components/auth';
import { AssurityLifeModal } from 'common/components/assurity-life-modal/assurity-life-modal';
import useStyles from './additional-offers-section.styles';
import { track } from 'core/helpers/analytics';
import useSession from 'core/hooks/use-session';
import { AssurityOffer } from 'common/components/assurity-offer/assurity-offer';

export const AdditionalOffersSection = observer(function AdditionalOffersSection({
  assurityTermLife = false,
  assurityTermLifeData
}) {
  const {
    offer: { offer },
    additionalOffers
  } = useStore();
  const {
    user: { affinityCode }
  } = useSession();

  const location = window.location.href;
  const webUserId = offer?.webUserId;

  useEffect(() => {
    if (webUserId && webUserId !== additionalOffers?.webUserId) {
      additionalOffers.getAdditionalOfferData(webUserId);
    }
  }, [webUserId, additionalOffers]);

  const allPeople = [...(offer.quote.drivers || []), ...(offer.quote.nonDrivers || [])];

  const [showAssurityTermLifeModal, setShowAssurityTermLifeModal] = useState(false);

  const openAssurityTermLifeModal = async () => {
    setShowAssurityTermLifeModal(true);
    track('Agent Clicked View Life Offer', {
      URL: location,
      preBindId: webUserId,
      affinityCode
    });
  };

  const { viewOnly } = useContext(AuthContext);

  const classes = useStyles();

  return (
    <>
      <Label type="darkGreenMedium" component="div" className={classes.sectionTitleLabel}>
        Additional Offers
      </Label>
      {assurityTermLife && (
        <AssurityOffer
          assurityTermLifeData={assurityTermLifeData}
          allPeople={allPeople}
          onOpenOffersClicked={openAssurityTermLifeModal}
          openOffersButtonDisabled={viewOnly}
        />
      )}
      {showAssurityTermLifeModal && (
        <AssurityLifeModal
          open={showAssurityTermLifeModal}
          assurityData={assurityTermLifeData}
          onClose={() => setShowAssurityTermLifeModal(false)}
          people={allPeople}
        />
      )}
    </>
  );
});

AdditionalOffersSection.propTypes = {
  branchTermLife: PropTypes.bool,
  assurityTermLife: PropTypes.bool,
  assurityTermLifeData: PropTypes.object
};
